// Monetization config — public, non-secret identifiers, safe to ship in the
// bundle.
//
// AdSense is PROD-ONLY: it loads/serves only when REACT_APP_ENV === 'prod' (the
// same build-time signal firebase/Init.js uses to pick the prod project, set to
// 'prod' by the CI merge workflow for mogged.app). Off-prod (dev, staging,
// localhost) the client id is empty → adsEnabled() is false, the banner never
// renders, and the loader in public/index.html is gated off too. This protects
// the AdSense account from invalid-traffic flags on non-production traffic.
//
//   ADSENSE_CLIENT_ID (public)    - AdSense publisher id, prod-only
//   REACT_APP_ADSENSE_BANNER_SLOT - the mobile bottom-banner ad-unit slot id
//
// In CI the slot comes from a dedicated GitHub secret (ADSENSE_BANNER_SLOT_PROD)
// appended to the env file by the hosting workflow; locally, from the gitignored
// .env.{dev,prod}. Unset until AdSense approval — empty keeps the banner off.
//
// NOTE the offerwall is gone. `OFFERWALL_URL` / `offerwallEnabled()` /
// `offerwallUrlFor()` and the `REACT_APP_OFFERWALL_URL` env var were removed
// along with rewardFunctions/offerwallPostback.js and UnlockScanModal: extra
// daily scans are no longer purchasable with ad completions. The daily limit
// still exists — a blocked free user waits for the UTC reset or subscribes.
// The OFFERWALL_URL_{PROD,DEV} GitHub secrets and any REACT_APP_OFFERWALL_URL
// lines in .env.{dev,prod} are now dead and can be deleted.

const IS_PROD = process.env.REACT_APP_ENV === 'prod';

// Public AdSense publisher id (ca-pub-…). Committed intentionally: it's public
// (visible in page source) and hardcoding it survives the gitignored env files.
export const ADSENSE_CLIENT_ID = IS_PROD ? 'ca-pub-3163806912601269' : '';
export const ADSENSE_BANNER_SLOT = IS_PROD ? (process.env.REACT_APP_ADSENSE_BANNER_SLOT || '') : '';

export const adsEnabled = () => Boolean(ADSENSE_CLIENT_ID && ADSENSE_BANNER_SLOT);
